var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
var CustomerDaDataComponent = /** @class */ (function () {
    function CustomerDaDataComponent(apiService, util, fb, activatedRoute) {
        this.apiService = apiService;
        this.util = util;
        this.fb = fb;
        this.activatedRoute = activatedRoute;
        this.submitted = false;
        this.contactId = "";
        this.contact = {};
        this.idNo = "";
        this.getDAList = {};
        this.displayStyle = "none";
        this.idnonmasking = "";
        this.emailnonmasking = "";
        this.telnonmasking = "";
        this.mobilenomasking = "";
        this.accnomasking = "";
        this.accnomaskingAll = "";
        this.accmaskingAll = "";
        this.idmasking = "";
        this.emailmasking = "";
        this.telmasking = "";
        this.mobilemasking = "";
        this.accmasking = "";
        this.authorize_user = "";
        this.authorize_password = "";
        this.form = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }
    Object.defineProperty(CustomerDaDataComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    CustomerDaDataComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CustomerDaDataComponent.prototype.initData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 1:
                        _a.contact = _c.sent();
                        this.idNo = this.contact.dpa_idcard;
                        _b = this;
                        return [4 /*yield*/, this.getDA()];
                    case 2:
                        _b.getDAList = _c.sent();
                        //console.log(this.getDAList)
                        if (this.getDAList != null && this.idNo != null) {
                            this.maskingid(this.idNo, 4);
                            this.maskingTelephone(this.getDAList.Telephone, 5);
                            this.maskingMobile(this.getDAList.MobileNumber, 5);
                            this.maskingEmail(this.getDAList.EmailAddress, 2);
                            this.maskingAccount(this.getDAList.AccountList, 4);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDaDataComponent.prototype.init = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.contactId = id;
                        //this.idNo = "1100000000031";
                        return [4 /*yield*/, this.initData()];
                    case 1:
                        //this.idNo = "1100000000031";
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDaDataComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.contactId;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    CustomerDaDataComponent.prototype.getDA = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "idNo=" + this.idNo;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getDA", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    CustomerDaDataComponent.prototype.displayPopup = function () {
        this.form.controls["username"].setValue("");
        this.form.controls["password"].setValue("");
        this.displayStyle = "block";
    };
    CustomerDaDataComponent.prototype.close = function () {
        this.displayStyle = "none";
    };
    CustomerDaDataComponent.prototype.authorize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, user_1, roleList, role, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        this.submitted = true;
                        if (!this.form.valid) return [3 /*break*/, 9];
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.apiService.post("crmservice", "callcenterLogin", this.form.value)];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 8];
                        if (!(res.RESCODE == "0" && res.RESMSG == "SUCCESS")) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)];
                    case 2:
                        user_1 = _a.sent();
                        if (!(user_1[0].statuscode == 1)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiService.get("master", "customwebrole")];
                    case 3:
                        roleList = _a.sent();
                        role = roleList.filter(function (r) {
                            return r.dpa_customwebroleid == user_1[0].dpa_roleid;
                        });
                        //console.log(role[0].dpa_name);
                        if (role[0].dpa_name.indexOf("Supervisor") == -1) {
                            this.util.WarningDialog("ไม่ได้รับอนุญาตให้ดูข้อมูลเพิ่มเติม");
                        }
                        else {
                            this.idmasking = this.idnonmasking;
                            this.emailmasking = this.emailnonmasking;
                            this.telmasking = this.telnonmasking;
                            this.mobilemasking = this.mobilenomasking;
                            this.accmaskingAll = this.accnomaskingAll;
                            this.displayStyle = "none";
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.util.WarningDialog("ไม่ได้รับอนุญาตให้ดูข้อมูลเพิ่มเติม");
                        _a.label = 5;
                    case 5:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 7];
                    case 6:
                        this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง");
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง");
                        _a.label = 9;
                    case 9:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 11];
                    case 10:
                        ex_1 = _a.sent();
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog(ex_1);
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    CustomerDaDataComponent.prototype.maskingid = function (refid, digittoshow) {
        if (refid != null && refid != "" && refid != "N/A") {
            var idnonmask = refid.substring(0, digittoshow);
            var digitidmask = 5;
            var domainnonmask = refid.substring(9, refid.length);
            var xmark = "";
            for (var i = 0; i < digitidmask; i++) {
                xmark = xmark + "x";
            }
            this.idnonmasking = refid;
            this.idmasking = idnonmask + xmark + domainnonmask;
        }
        else {
            this.idnonmasking = refid;
            this.idmasking = refid;
        }
    };
    CustomerDaDataComponent.prototype.maskingEmail = function (email, digittoshow) {
        if (email != null && email != "" && email != "N/A") {
            var digitofmail = email.indexOf("@");
            var emailnonmask = email.substring(0, digittoshow);
            var digitemailmask = email.substring(digittoshow, digitofmail).length;
            var domainnonmask = email.substring(digitofmail, email.length);
            var xmark = "";
            for (var i = 0; i < digitemailmask; i++) {
                xmark = xmark + "x";
            }
            this.emailnonmasking = email;
            this.emailmasking = emailnonmask + xmark + domainnonmask;
        }
        else {
            this.emailnonmasking = email;
            this.emailmasking = email;
        }
    };
    CustomerDaDataComponent.prototype.maskingTelephone = function (tel, digittomask) {
        if (tel != null && tel != "" && tel != "N/A") {
            var telonmask = tel.substring(digittomask, tel.length);
            var xmark = "";
            for (var i = 0; i < digittomask; i++) {
                xmark = xmark + "x";
            }
            this.telnonmasking = tel;
            this.telmasking = xmark + telonmask;
        }
        else {
            this.telnonmasking = tel;
            this.telmasking = tel;
        }
    };
    CustomerDaDataComponent.prototype.maskingAccount = function (acc, digittomask) {
        var accnomasking = "";
        var accmasking = "";
        var nomarkall = "";
        var maskinall = "";
        if (acc !== undefined) {
            if (acc.length > 0) {
                for (var j = 0; j < acc.length; j++) {
                    accnomasking = "";
                    accmasking = "";
                    if (acc[j].AccountNumber != null && acc[j].AccountNumber != "" && acc[j].AccountNumber != "N/A") {
                        var mark = acc[j].AccountNumber.length - digittomask;
                        var telonmask = acc[j].AccountNumber.substring(mark, acc[j].AccountNumber.length);
                        var xmark = "";
                        for (var i = 0; i < mark; i++) {
                            xmark = xmark + "x";
                        }
                        accnomasking = acc[j].AccountNumber;
                        accmasking = xmark + telonmask;
                    }
                    else {
                        accnomasking = acc[j].AccountNumber;
                        accmasking = acc[j].AccountNumber;
                    }
                    nomarkall = nomarkall + accnomasking + "\n";
                    maskinall = maskinall + accmasking + "\n";
                }
            }
        }
        this.accmaskingAll = maskinall;
        this.accnomaskingAll = nomarkall;
    };
    CustomerDaDataComponent.prototype.maskingMobile = function (refmobile, digittomask) {
        if (refmobile != null && refmobile != "" && refmobile != "N/A") {
            var mobilemask = refmobile.substring(digittomask, refmobile.length);
            var xmark = "";
            for (var i = 0; i < digittomask; i++) {
                xmark = xmark + "x";
            }
            this.mobilenomasking = refmobile;
            this.mobilemasking = xmark + mobilemask;
        }
        else {
            this.mobilenomasking = refmobile;
            this.mobilemasking = refmobile;
        }
    };
    return CustomerDaDataComponent;
}());
export { CustomerDaDataComponent };



// WEBPACK FOOTER //
// ./src/app/customer-da-data/customer-da-data.component.ts.pre-build-optimizer.js